import { render, staticRenderFns } from "./DigitalAgency.vue?vue&type=template&id=4df6fa48&"
import script from "./DigitalAgency.vue?vue&type=script&lang=js&"
export * from "./DigitalAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports